const getters = {
    isAuthenticated: state => !!state.access_token,
    hasLoadedOnce: state => state.hasLoadedOnce,
    authStatus: state => state.status,
    authErrors: state => state.authErrors,
};

export default getters;
